<template>
  <div :class="widgetData.container">
    <div class="row">
      <div id="acc_list_1_3" class="acc_list_1_3 col-12">
        <div class="section-title my-4 my-xl-4 my-xxl-5" v-if="widgetData.description">
          <h2 v-html="widgetData.description" v-if="widgetData.description"></h2>
        </div>

        <div class="row" v-if="content && content.length > 0">
          <div class="col-12 col-md-6 col-lg-4 col-xl-4 col-xxl-3 card-group"
               v-for="accommodation in content"
               :key="'acc_item_' + accommodation.id">

            <WidgetAccommodationListAccList13Item :accommodation="accommodation" :activeLocale="activeLocale"
                                                  :activeCountry="activeCountry" :widgetName="widgetData.title"
                                                  :currency="activeLocaleCurrency"
                                                  :GATrackEvent="GATrackEvent"/>


          </div>
          <div class="col-12 py-5 pagination-group" v-if="widgetData.custom_params && widgetData.custom_params.pagination">
            <PartsTempPreloader v-if="loading"/>

            <div class="row d-flex">
              <div class="col-12 col-lg-3 text-center text-lg-center mb-3 mb-lg-0">
                {{ $t('pager-showed') }} 1-{{ (page + 1) * widgetData.custom_params.limit }}
              </div>
              <div class="col-12 col-lg-6 text-center">
                <div class="btn btn-first btn-rounded px-5 py-3" @click="loadMoreItems">{{ $t('load-more') }}
                </div>
              </div>
            </div>

          </div>
        </div>

        <div class="row" v-else>
          <div class="col-12">
            <div class="alert alert-info">
              {{ $t('there-is-no-accommodation-in-list') }}
            </div>
          </div>
        </div>


      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import "~/assets/less/acc_list_1_3.min.css";
import {useNuxtApp} from "#app";
import {onMounted, PropType, ref} from "vue";
import {PageDataHolderFetchedWidget} from "~/lib/interfaces/model/PageDataHolderFetchedWidget";
import {useWidget} from "~/composables/widget/accommodation_list";
import {obtainActiveLocale} from "../../../../composables/master_page";
import Accommodation from "../../../../lib/models/Accommodation";
import {useRoute, useRouter} from "#app";
import PlaceCountry from "../../../../lib/models/PlaceCountry";
import {GATracker} from "../../../../composables/ga_tracker";

const {$vysklonujSlovo, $tyrionApi} = useNuxtApp();
const props = defineProps({
  widget: Object as PropType<PageDataHolderFetchedWidget>
});

const page = ref(0);
const loading = ref(false);
const {widgetData, content, activeLocale, activeLocaleCurrency, activeCountry} = useWidget(props.widget);
const {GATrackEvent} = GATracker();

const loadMoreItems = () => {
  if (widgetData.custom_params && widgetData.custom_params.pagination) {
    loading.value = true;

    $tyrionApi.getTyrionUrl(`/api3/widget/accommodation_list/${widgetData.code}`, {
      query: {page: page.value + 1, langCode: activeLocale.code},
      cacheTime: (2 * 60 * 60)
    }).then(response => {
      if (response.data.content.length > 0) {
        page.value++;

        useRouter().replace({query: {page: page.value}});

        loading.value = false;
        response.data.content.forEach(c => {
          content.push((new Accommodation()).fromObject(c))
        })
      } else {
        loading.value = false;
      }

    });

    GATrackEvent({
      event: 'load_more_accommodations',
      language: activeLocale.code,
      action: 'click',
      label: 'Load more accomodations',
      widget: widgetData.title,
    });

  }
}


if (useRoute().query.page > 0) {
  const pageQuery = Number(useRoute().query.page);

  loading.value = true;
  for (let i = content.length; i < widgetData.custom_params.limit * (pageQuery + 1); i++) {
    const acc = new Accommodation();
    acc.location.country = new PlaceCountry();
    content.push(acc);
  }
}

onMounted(() => {
  if (useRoute().query.page > 0) {
    const pageQuery = Number(useRoute().query.page);

    $tyrionApi.getTyrionUrl(`/api3/widget/accommodation_list/${widgetData.code}`, {
      query: {page: pageQuery, activeLocale: activeLocale.code, offset: widgetData.custom_params.limit},
      cacheTime: (2 * 60 * 60)
    }).then(response => {
      page.value = pageQuery;
      loading.value = false;
      response.data.content.forEach(c => {
        content.splice(content.findIndex(a => a.id < 1), 1);
        content.push((new Accommodation()).fromObject(c))
      });

      while (content.some(a => a.id < 1)) {
        content.splice(content.findIndex(a => a.id < 1), 1);
      }

    })


    page.value = pageQuery + 1;


  }
})

</script>
